<template>
  <form @submit="onSubmit">
    <div
      class="py-4 px-4 sm:px-8 bg-[#F9FAFC] w-full mt-8 flex flex-col gap-y-15 pt-8 rounded-md"
    >
      <!-- Sample 1 Section -->
      <div class="flex flex-col gap-y-8">
        <div class="flex gap-x-2 items-center">
          <svg
            class="w-8 h-8 sm:w-13 sm:h-13"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4197_6477)">
              <path
                d="M0.333984 25.5C0.333984 18.8696 2.96791 12.5107 7.65632 7.82233C12.3447 3.13392 18.7036 0.5 25.334 0.5C31.9644 0.5 38.3232 3.13392 43.0117 7.82233C47.7001 12.5107 50.334 18.8696 50.334 25.5C50.334 32.1304 47.7001 38.4893 43.0117 43.1777C38.3232 47.8661 31.9644 50.5 25.334 50.5C18.7036 50.5 12.3447 47.8661 7.65632 43.1777C2.96791 38.4893 0.333984 32.1304 0.333984 25.5ZM25.334 28.625C24.5052 28.625 23.7103 28.2958 23.1243 27.7097C22.5382 27.1237 22.209 26.3288 22.209 25.5C22.209 24.6712 22.5382 23.8763 23.1243 23.2903C23.7103 22.7042 24.5052 22.375 25.334 22.375C26.1628 22.375 26.9576 22.7042 27.5437 23.2903C28.1297 23.8763 28.459 24.6712 28.459 25.5C28.459 26.3288 28.1297 27.1237 27.5437 27.7097C26.9576 28.2958 26.1628 28.625 25.334 28.625ZM15.959 25.5C15.959 27.9864 16.9467 30.371 18.7049 32.1291C20.463 33.8873 22.8476 34.875 25.334 34.875C27.8204 34.875 30.205 33.8873 31.9631 32.1291C33.7213 30.371 34.709 27.9864 34.709 25.5C34.709 23.0136 33.7213 20.629 31.9631 18.8709C30.205 17.1127 27.8204 16.125 25.334 16.125C22.8476 16.125 20.463 17.1127 18.7049 18.8709C16.9467 20.629 15.959 23.0136 15.959 25.5ZM9.70898 23.9375C9.70898 20.5195 11.418 16.9941 14.123 14.2891C16.8281 11.584 20.3535 9.875 23.7715 9.875C24.6309 9.875 25.334 9.17188 25.334 8.3125C25.334 7.45312 24.6309 6.75 23.7715 6.75C19.3379 6.75 15.0605 8.92773 11.9062 12.0723C8.75195 15.2168 6.58398 19.5039 6.58398 23.9375C6.58398 24.7969 7.28711 25.5 8.14648 25.5C9.00586 25.5 9.70898 24.7969 9.70898 23.9375Z"
                fill="#EEC45C"
              />
            </g>
            <defs>
              <clipPath id="clip0_4197_6477">
                <rect
                  width="50"
                  height="50"
                  fill="white"
                  transform="translate(0.333984 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
          <h3 class="text-xl sm:text-2xl text-black font-medium">Track 1</h3>
        </div>

        <!-- Before and After Files Side by Side -->
        <div class="flex flex-col gap-y-8 lg:gap-y-0 lg:flex-row gap-x-15">
          <div class="flex flex-col gap-y-6 flex-1">
            <h4 class="text-xl font-medium">Before Mixing and Mastering</h4>
            <FileUploader
              v-model="beforeFile1"
              v-bind="beforeFile1Attrs"
              :disabled="isFormDisabled"
            />
          </div>

          <div class="flex flex-col gap-y-6 flex-1">
            <h4 class="text-xl font-medium">After Mixing and Mastering</h4>
            <FileUploader
              v-model="afterFile1"
              v-bind="afterFile1Attrs"
              :disabled="isFormDisabled"
            />
          </div>
        </div>
        
        <!-- Single Description for Sample 1 -->
        <div class="flex flex-col gap-y-2 mt-2">
          <label class="font-medium text-[#7B7979] text-base sm:text-lg"
            >Description</label
          >
          <Field name="description1" v-slot="{ field, errors }">
            <textarea
              v-bind="field"
              placeholder="Describe the audio characteristics and improvements made..."
              :class="{ 'ring-red-500 border-red-500': errors[0] }"
              :disabled="isFormDisabled"
            ></textarea>
          </Field>
          <ErrorMessage name="description1" class="text-sm text-red-500" />
        </div>
      </div>

      <!-- Sample 2 Section -->
      <div class="flex flex-col gap-y-8 mt-8">
        <div class="flex gap-x-2 items-center">
          <svg
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 h-8 sm:w-13 sm:h-13"
          >
            <g clip-path="url(#clip0_4197_6477)">
              <path
                d="M0.333984 25.5C0.333984 18.8696 2.96791 12.5107 7.65632 7.82233C12.3447 3.13392 18.7036 0.5 25.334 0.5C31.9644 0.5 38.3232 3.13392 43.0117 7.82233C47.7001 12.5107 50.334 18.8696 50.334 25.5C50.334 32.1304 47.7001 38.4893 43.0117 43.1777C38.3232 47.8661 31.9644 50.5 25.334 50.5C18.7036 50.5 12.3447 47.8661 7.65632 43.1777C2.96791 38.4893 0.333984 32.1304 0.333984 25.5ZM25.334 28.625C24.5052 28.625 23.7103 28.2958 23.1243 27.7097C22.5382 27.1237 22.209 26.3288 22.209 25.5C22.209 24.6712 22.5382 23.8763 23.1243 23.2903C23.7103 22.7042 24.5052 22.375 25.334 22.375C26.1628 22.375 26.9576 22.7042 27.5437 23.2903C28.1297 23.8763 28.459 24.6712 28.459 25.5C28.459 26.3288 28.1297 27.1237 27.5437 27.7097C26.9576 28.2958 26.1628 28.625 25.334 28.625ZM15.959 25.5C15.959 27.9864 16.9467 30.371 18.7049 32.1291C20.463 33.8873 22.8476 34.875 25.334 34.875C27.8204 34.875 30.205 33.8873 31.9631 32.1291C33.7213 30.371 34.709 27.9864 34.709 25.5C34.709 23.0136 33.7213 20.629 31.9631 18.8709C30.205 17.1127 27.8204 16.125 25.334 16.125C22.8476 16.125 20.463 17.1127 18.7049 18.8709C16.9467 20.629 15.959 23.0136 15.959 25.5ZM9.70898 23.9375C9.70898 20.5195 11.418 16.9941 14.123 14.2891C16.8281 11.584 20.3535 9.875 23.7715 9.875C24.6309 9.875 25.334 9.17188 25.334 8.3125C25.334 7.45312 24.6309 6.75 23.7715 6.75C19.3379 6.75 15.0605 8.92773 11.9062 12.0723C8.75195 15.2168 6.58398 19.5039 6.58398 23.9375C6.58398 24.7969 7.28711 25.5 8.14648 25.5C9.00586 25.5 9.70898 24.7969 9.70898 23.9375Z"
                fill="#EEC45C"
              />
            </g>
            <defs>
              <clipPath id="clip0_4197_6477">
                <rect
                  width="50"
                  height="50"
                  fill="white"
                  transform="translate(0.333984 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
          <h3 class="text-xl sm:text-2xl text-black font-medium">Track 2</h3>
        </div>

        <!-- Before and After Files Side by Side -->
        <div class="flex flex-col gap-y-8 lg:gap-y-0 lg:flex-row gap-x-15">
          <div class="flex flex-col gap-y-6 flex-1">
            <h4 class="text-xl font-medium">Before Mixing and Mastering</h4>
            <FileUploader
              v-model="beforeFile2"
              v-bind="beforeFile2Attrs"
              :disabled="isFormDisabled"
            />
          </div>

          <div class="flex flex-col gap-y-6 flex-1">
            <h4 class="text-xl font-medium">After Mixing and Mastering</h4>
            <FileUploader
              v-model="afterFile2"
              v-bind="afterFile2Attrs"
              :disabled="isFormDisabled"
            />
          </div>
        </div>
        
        <!-- Single Description for Sample 2 -->
        <div class="flex flex-col gap-y-2 mt-2">
          <label class="font-medium text-[#7B7979] text-base sm:text-lg"
            >Description</label
          >
          <Field name="description2" v-slot="{ field, errors }">
            <textarea
              v-bind="field"
              placeholder="Describe the audio characteristics and improvements made..."
              :class="{ 'ring-red-500 border-red-500': errors[0] }"
              :disabled="isFormDisabled"
            ></textarea>
          </Field>
          <ErrorMessage name="description2" class="text-sm text-red-500" />
        </div>
      </div>
    </div>

    <!-- <div class="flex flex-col w-full px-4 py-8 bg-[#EEF2FD] rounded-md mt-10">
      <h3 class="font-medium text-black text-lg sm:text-xl">
        Please ensure that both checkboxes are selected before submitting
      </h3>
      <div
        class="flex items-start gap-x-0 mt-4 flex-col sm:items-center gap-y-2 sm:flex-row sm:gap-y-2 sm:gap-x-2"
      >
        <div class="sm:contents flex items-start">
          <Field
            name="exclusiveSubmissionAgreement"
            type="checkbox"
            class="h-5 w-full max-w-[20px] cursor-pointer transition-all appearance-none rounded-md border border-slate-300 checked:bg-principal-500 checked:border-principal-500"
            id="exclusiveSubmissionAgreement"
            value="true"
            :disabled="isFormDisabled"
          >
          </Field>
          <label
            for="exclusiveSubmissionAgreement"
            class="text-sm sm:text-base text-black cursor-pointer ml-2"
          >
            I authorize the exclusive use of my work for internal purposes, including
            dataset creation for AI advancements.
          </label>
        </div>
        <ErrorMessage
          name="exclusiveSubmissionAgreement"
          class="text-sm text-red-500 w-full text-center sm:text-start"
        />
      </div>
    </div> -->

    <div class="flex justify-between w-full py-8 px-2 sm:px-0">
      <button
        @click="backStep"
        class="btn-secondary px-4 py-2"
        :disabled="isFormDisabled"
      >
        Back
      </button>
      <!-- <ButtonComponent @click="onSubmit" :class="['btn-primary', 'flex', 'gap-y-2', 'items-center']" :loading="props.loading" :disabled="isFormDisabled"/> -->
      <button @click="onSubmit" class="btn-primary" :disabled="isFormDisabled">
        Next
      </button>
    </div>
  </form>
</template>

<script setup>
import { defineEmits, onMounted, defineProps, computed } from "vue";
import { useForm, ErrorMessage, Field } from "vee-validate";
import * as yup from "yup";
import FileUploader from "@/shared/component/FileUploader.vue";
// import ButtonComponent from "@/shared/component/ButtonComponent.vue";

const emit = defineEmits(["back", "next"]);
const props = defineProps({
  loading: Boolean,
});

// Computed property to determine if form should be disabled
const isFormDisabled = computed(() => props.loading);

const schema = yup.object({
  beforeFile1: yup.mixed().required("File is required"),
  afterFile1: yup.mixed().required("File is required"),
  description1: yup.string().required("Description is required").min(5, "Description must be at least 5 characters").max(500, "Description must be at most 500 characters"),
  beforeFile2: yup.mixed().required("File is required"),
  afterFile2: yup.mixed().required("File is required"),
  description2: yup.string().required("Description is required").min(5, "Description must be at least 5 characters").max(500, "Description must be at most 500 characters"),
  /* exclusiveSubmissionAgreement: yup
    .boolean()
    .required("This field is required")
    .oneOf([true], "This field is required"), */
});

const { defineField, handleSubmit } = useForm({
  validateOnInput: true,
  validationSchema: schema,
});

const [beforeFile1, beforeFile1Attrs] = defineField("beforeFile1", {
  props: (state) => ({ error: state.errors[0] }),
});
const [afterFile1, afterFile1Attrs] = defineField("afterFile1", {
  props: (state) => ({ error: state.errors[0] }),
});
const [beforeFile2, beforeFile2Attrs] = defineField("beforeFile2", {
  props: (state) => ({ error: state.errors[0] }),
});
const [afterFile2, afterFile2Attrs] = defineField("afterFile2", {
  props: (state) => ({ error: state.errors[0] }),
});

const onSubmit = handleSubmit((values) => {
  emit("next", values);
});

const backStep = () => {
  emit("back");
};

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>
